import { ILangText } from "../ILangText";


const labels:{ [k:string]:ILangText } = {
	"computeChannelAverage":{
		en:"Compute Channel Average",
		is:"",
	},
	"computeGroupAverage":{
		en:"Compute Group Average",
		is:"",
	},
	"countChannelOptions":{
		en:"Count Channel Options",
		is:"",
	},
	"countChannelValue":{
		en:"Count Channel Value",
		is:"",
	},
	"countStudySessions":{
		en:"Count Survey Sessions",
		is:"",
	},
	"findMaxChannelAverage":{
		en:"Find Max Channel Average",
		is:"",
	},
	"findMinChannelAverage":{
		en:"Find Min Channel Average",
		is:"",
	},
	"computeChannelAverages":{
		en:"Compute Channel Averages",
		is:"",
	},
	"countGroupBooleans":{
		en:"Count Group Booleans",
		is:"",
	},
	"number":{
		en:"Number",
		is:"Tala",
	},
	"string":{
		en:"String",
		is:"Texti",
	},
	"channelGroup":{
		en:"Group",
		is:"Yfirflokkur",
	},
	"configureDataSource":{
		en:"Data Source",
		is:"Gögn",
	},
	"chooseRenderTemplate":{
		en:"Render Template",
		is:"Útlitssnið",
	},
	"bindDataToTemplate":{
		en:"Bind Data",
		is:"Binda gögn",
	},
	"confirmConfiguration":{
		en:"Confirm",
		is:"Staðfesta",
	},
	"dataSources":{
		en:"Data Sources",
		is:"Gögn",
	},
	"template":{
		en:"Template",
		is:"Snið",
	},
	"widgetName":{
		en:"Widget Name",
		is:"Nafn",
	},
	"textColor":{
		en:"Text Color",
		is:"Textalitur",
	},
	"color":{
		en:"Color",
		is:"Litur",
	},
	"icon":{
		en:"Icon",
		is:"Tákn",
	},
	"iconColor":{
		en:"Icon Color",
		is:"Táknlitur",
	},
	"backgroundColor":{
		en:"Background Color",
		is:"Backgrunnslitur",
	},
	"channel":{
		en:"Channel",
		is:"Rás",
	},
	"dataParameters":{
		en:"Data Parameters",
		is:"Gagnafæribreytur"
	},
	"templateProperties":{
		en:"Template Properties",
		is:"Sniðstillingar"
	},
	"title":{
		en:"Title",
		is:"Titill",
	},
	"borderColor":{
		en:"Border Color",
		is:"Umgjarðarlitur",
	},
	"sort":{
		en:"Sort",
		is:"Röðun",
	},
	"type":{
		en:"Type",
		is:"Tegund",
	},
};

const actions:{ [k:string]:ILangText } = {
	"createWidget":{
		en:"Create Widget",
		is:"Búa til skjától",
	},
	"unbind":{
		en:"Unbind",
		is:"Afbinda",
	},
	"renameWidget":{
		en:"Rename Widget",
		is:"Endurskýra skjától"
	},
	"deleteWidget":{
		en:"Delete Widget",
		is:"Eyða skjátóli"
	}
};

const messages:{ [k:string]:ILangText } = {
	"dataIncompatibleWithTemplate":{
		en:"Data is incompatible with template.",
		is:"Gögn passa ekki við snið."
	}
};



const widgets:{ [k:string]:ILangText }  = {};


Object.keys(labels).forEach(k => widgets[`widgets.label.${k}`] = labels[k]);
Object.keys(actions).forEach(k => widgets[`widgets.action.${k}`] = actions[k]);
Object.keys(messages).forEach(k => widgets[`widgets.message.${k}`] = messages[k]);

export { widgets }